import React from 'react';
import './Introduction.css';

const Introduction: React.FC = () => {
  return (
    <div className="introduction">
      <h2>Transform Your World with Crafty_Kla Crochet Creations!</h2>
      
      <p>
        At <em>Crafty_Kla</em>, we turn yarn into art! Whether you're looking to add a cozy touch to your home or searching for the perfect handmade gift, we've got you covered with our exquisite, custom crochet creations.
      </p>

      <h3>Why Crafty_Kla?</h3>
      <ul>
        <li>✨ <em>Handmade with Love</em>: Each product is carefully crafted by skilled artisans who pour their passion into every stitch.</li>
        <li>✨ <em>Tailored Just for You</em>: From custom designs to personalized gifts, we create pieces that reflect your unique style and needs.</li>
        <li>✨ <em>Quality You Can Feel</em>: Soft, durable, and eco-friendly materials are used to ensure long-lasting beauty and comfort.</li>
        <li>✨ <em>Affordable Luxury</em>: Enjoy handcrafted crochet at prices that are as friendly as our products.</li>
      </ul>

      <p>
        From snug blankets to charming accessories and thoughtful gifts, <em>Crafty_Kla</em> delivers timeless crochet treasures that bring warmth and joy.
      </p>

      <p>
        <em>Get Crafty with Crafty_Kla Today</em> – Follow us for exclusive offers, new arrivals, and more!
      </p>

      <p className="tagline">
        <em>Crafty_Kla</em> – Where every stitch is a work of art!
      </p>
    </div>
  );
};

export default Introduction;
